<template>
    <div>
        <card title="Motivo de Muestra" icon="far fa-dot-circle">
            <master-options @showModal="showModal" :links="links" @index="index" @reset="reset"></master-options>
            <div class="table-responsive">
                <manage-table :hover="true" :headers="['Id', 'Nombre', 'Fecha Creación', 'Fecha Actualización']"
                    :hasOptions="true">
                    <tr v-for="sr in sampleReasonList" :key="sr.id">
                        <td>{{ sr.id }}</td>
                        <td>{{ sr.name }}</td>
                        <td>{{ sr.createdAtString }}</td>
                        <td>{{ sr.updatedAtString }}</td>
                        <td>
                            <button class="btn btn-info btn-sm mr-2" @click="showModal(sr)" data-toggle="tooltip"
                                data-placement="top" title="Editar Motivo de Muestra">
                                <i class="fas fa-edit"></i>
                            </button>
                            <button title="Eliminar Motivo de Muestra" class="btn btn-danger btn-sm "
                                @click="deleteSampleReason(sr.id, sr.name)" data-toggle="tooltip" data-placement="top">
                                <i class="fas fa-trash"></i>
                            </button>
                        </td>
                    </tr>
                </manage-table>
            </div>
            <paginator class="mt-4" :links="links"></paginator>
        </card>
        <modal id="sampleReasonFormModal" :title="modalTitle" @modalClose="index">
            <sample-reason-form :sReason="sReason" @pressOk="save"></sample-reason-form>
        </modal>
    </div>
</template>

<script>
import { Get, Delete, Post, Put } from "../../helper/axios.js";
import Card from "../../components/Card.vue";
import $ from "jquery";
import { getUrlQuery } from "../../helper/queryHelper.js";
export default {
    components: {
        Card
    },
    data() {
        return {
            sampleReasonList: [],
            Post,
            Delete,
            apiUrl: this.$store.getters.apiUrl,
            modalTitle: '',
            Get,
            Put,
            sReason: {},
            links: {},
            getUrlQuery
        };
    },
    watch: {
        urlQuery: function () {
            this.index()
        }
    },
    created() {
        this.index();
    },
    methods: {
        index() {
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl + "v1/sampleReasons?" + this.urlQuery, res => {
                this.sampleReasonList = res.data.data;
                this.links = res.data.links;
                this.$store.commit("setLoading", false);
            });

        },
        reset() {
            this.links = {}
            this.index()
        },
        save() {
            if (this.sReason.id)
                this.update()
            else
                this.store()

        },
        showModal(reason) {
            if (reason && reason.id) {
                this.modalTitle = "Actualizar Motivo de Muestra";
                this.sReason = reason;
            } else {
                this.modalTitle = "Crear Motivo de Muestra";
                this.sReason = {};
            }
            $('#sampleReasonFormModal').modal('show');
        },
        deleteSampleReason(id, name) {
            this.$swal({
                title: "¿Desea eliminar el Motivo de Muestra?",
                text: name,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33"
            }).then(result => {
                if (result.value) {
                    this.Delete(this.apiUrl + 'v1/sampleReasons/' + id, () => {
                        window.toastr.success('Motivo de Muestra Eliminado correctamente.');
                        this.index();
                    });

                }

            });
        },
        update() {
            this.$store.commit("setLoading", true);
            this.Put(`${this.apiUrl}v1/sampleReasons/` + this.sReason.id, this.sReason, () => {
                $('#sampleReasonFormModal').modal('hide');
                this.$store.commit("setLoading", false);
                window.toastr.success('Motivo de Muestra Actualizado correctamente.');
                this.reset();
            });

        },
        store() {
            this.$store.commit("setLoading", true);
            this.Post(`${this.apiUrl}v1/sampleReasons/`, this.sReason, () => {
                $('#sampleReasonFormModal').modal('hide');
                this.$store.commit("setLoading", false);
                window.toastr.success('Motivo de Muestra Registrado correctamente.');
                this.sReason = {};
                this.reset();
            });

        }
    },
    computed: {
        urlQuery() {
            return this.getUrlQuery()
        }
    }

}

</script>